// Toggle the mobile menu open and close
export default function menuOpen() {
    const burgerButton = document.querySelector('.nm-burger');

    if (burgerButton) {
        burgerButton.addEventListener('click', function () {
            document.body.classList.toggle('nm-menu-open');
        });
    }

    // Close menu when clicking outside
    document.addEventListener('click', function(e) {
        if (document.body.classList.contains('nm-menu-open')) {
            const mobileMenu = document.querySelector('.nm-mobile-menu');
            const burger = document.querySelector('.nm-burger');

            if (mobileMenu && !mobileMenu.contains(e.target) && !burger.contains(e.target)) {
                document.body.classList.remove('nm-menu-open');
            }
        }
    });

    // Close menu on escape key
    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && document.body.classList.contains('nm-menu-open')) {
            document.body.classList.remove('nm-menu-open');
        }
    });
}
